import React from 'react';
import PropTypes from 'prop-types';

import { TooltipWithinSuiPopovers } from 'common/components/TooltipWithinSuiPopovers';
import { SuiModalFooter, SuiContainer, SuiButton, SuiStateButton } from '@splashthat/sui';

import { SAVING, DEFAULT, SAVING_LABEL, SAVED_LABEL } from './constants';

const COMPONENT_NAME = 'SaveModalFooter';

const SaveModalFooter = ({
    confirmButtonLabel,
    cancelButtonLabel,
    status,
    onCancel,
    onConfirm,
    disabledConfirmButton,
    isTooltipDisabled,
    tooltipLabel,
}) => (
    <SuiModalFooter>
        <SuiContainer variation="flex-group">
            <SuiButton
                label={cancelButtonLabel}
                data-qa={`${COMPONENT_NAME}__back_button`}
                onClick={onCancel}
                variation="secondary"
                disabled={status !== DEFAULT}
            />
        </SuiContainer>
        {onConfirm ? (
            <SuiContainer variation="flex-group">
                <TooltipWithinSuiPopovers
                    isDisabled={status !== DEFAULT || isTooltipDisabled}
                    side="right"
                    label={tooltipLabel}
                >
                    <span>
                        <SuiStateButton
                            label={confirmButtonLabel}
                            data-qa={`${COMPONENT_NAME}__button-save`}
                            onClick={onConfirm}
                            labelLoading={SAVING_LABEL}
                            labelDone={SAVED_LABEL}
                            disabled={disabledConfirmButton || status !== DEFAULT}
                            status={status === SAVING ? SuiStateButton.STATUS_LOADING : SuiStateButton.STATUS_READY}
                        />
                    </span>
                </TooltipWithinSuiPopovers>
            </SuiContainer>
        ) : null}
    </SuiModalFooter>
);

SaveModalFooter.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func,
    status: PropTypes.string.isRequired,
    disabledConfirmButton: PropTypes.bool,
    confirmButtonLabel: PropTypes.string,
    cancelButtonLabel: PropTypes.string,
    isTooltipDisabled: PropTypes.bool,
    tooltipLabel: PropTypes.string,
};

SaveModalFooter.defaultProps = {
    onConfirm: null,
    confirmButtonLabel: '',
    cancelButtonLabel: '',
    disabledConfirmButton: false,
    isTooltipDisabled: true,
    tooltipLabel: null,
};

export default SaveModalFooter;
